<div class="am-shell">

  <!-- ── Header ──────────────────────────────────────────────────────── -->
  <div class="am-head">
    <div class="am-head__tile">
      <lucide-icon name="wallet" [size]="16"></lucide-icon>
    </div>
    <div class="am-head__copy">
      <div class="am-head__title">
        {{ 'DATA.MODULES.SHARED.COMPONENTS.PARTIAL_PAYMENT.TITLE' | translate }}
      </div>
      <div class="am-head__sub">
        {{ 'DATA.MODULES.SHARED.COMPONENTS.PARTIAL_PAYMENT.FOR' | translate }}
        <strong>{{ customerName }}</strong>
        · {{ 'DATA.MODULES.SHARED.COMPONENTS.PARTIAL_PAYMENT.CASE_LABEL' | translate }}
        <strong>{{ caseName }}</strong>
      </div>
    </div>
    <button type="button" class="am-head__close" (click)="cancel()">
      <lucide-icon name="x" [size]="15"></lucide-icon>
    </button>
  </div>

  <!-- ── Body ────────────────────────────────────────────────────────── -->
  <div class="am-body">

    <!-- KPI tile -->
    <div class="am-kpi">
      <span class="am-kpi__icon">
        <lucide-icon name="dollar-sign" [size]="16"></lucide-icon>
      </span>
      <div class="am-kpi__content">
        <span class="am-kpi__label">
          {{ 'DATA.MODULES.SHARED.COMPONENTS.PARTIAL_PAYMENT.KPI_TOTAL_DEBT' | translate }}
        </span>
        <span class="am-kpi__value">
          {{ totalAmountFormatted }}
          <span class="am-kpi__unit">{{ currency }}</span>
        </span>
      </div>
    </div>

    <!-- CONFIGURACIÓN -->
    <h3 class="am-eyebrow">
      {{ 'DATA.MODULES.SHARED.COMPONENTS.PARTIAL_PAYMENT.SECTION_CONFIG' | translate }}
      <span class="line"></span>
    </h3>

    <!-- Importe mínimo -->
    <div class="am-field">
      <label class="am-field__label">
        {{ 'DATA.MODULES.SHARED.COMPONENTS.PARTIAL_PAYMENT.FORM.MIN_AMOUNT' | translate }}
        <span class="am-req">*</span>
      </label>
      <div class="am-amount-row">
        <input
          type="number"
          class="am-input am-input--flex"
          [(ngModel)]="minAmount"
          min="0"
          step="0.01"
        />
        <span class="am-amount-unit">{{ amountMode }}</span>
        <div class="am-segment">
          <button type="button" class="am-segment__btn" [class.is-active]="amountMode === 'EUR'" (click)="setAmountMode('EUR')">EUR</button>
          <button type="button" class="am-segment__btn" [class.is-active]="amountMode === '%'" (click)="setAmountMode('%')">%</button>
        </div>
      </div>
      <p class="am-equiv" *ngIf="minAmount > 0" [innerHTML]="equivHtml"></p>
    </div>

    <!-- Canal de envío -->
    <div class="am-field">
      <label class="am-field__label">
        {{ 'DATA.MODULES.SHARED.COMPONENTS.PARTIAL_PAYMENT.FORM.CHANNEL' | translate }}
        <span class="am-req">*</span>
      </label>
      <div class="am-channel-list am-channel-list--2col">
        <button
          type="button"
          class="am-channel"
          [class.is-selected]="selectedChannel === 'sendSMS'"
          (click)="selectChannel('sendSMS')"
          *ngIf="hasSms"
        >
          <span class="am-channel__icon">
            <lucide-icon name="smartphone" [size]="16"></lucide-icon>
          </span>
          <div class="am-channel__body">
            <span class="am-channel__name">SMS</span>
            <span class="am-channel__detail">{{ sms }}</span>
          </div>
          <span class="am-channel__radio" [class.is-checked]="selectedChannel === 'sendSMS'"></span>
        </button>
        <button
          type="button"
          class="am-channel"
          [class.is-selected]="selectedChannel === 'sendEmail'"
          (click)="selectChannel('sendEmail')"
          *ngIf="hasEmail"
        >
          <span class="am-channel__icon">
            <lucide-icon name="mail" [size]="16"></lucide-icon>
          </span>
          <div class="am-channel__body">
            <span class="am-channel__name">Email</span>
            <span class="am-channel__detail">{{ email }}</span>
          </div>
          <span class="am-channel__radio" [class.is-checked]="selectedChannel === 'sendEmail'"></span>
        </button>
      </div>
    </div>

    <!-- Plantilla -->
    <div class="am-field">
      <label class="am-field__label">
        {{ 'DATA.MODULES.SHARED.COMPONENTS.PARTIAL_PAYMENT.FORM.TEMPLATE' | translate }}
        <span class="am-req">*</span>
      </label>
      <p-dropdown
        [(ngModel)]="selectedCopyId"
        [options]="copiesOptions"
        optionLabel="label"
        optionValue="value"
        [placeholder]="'DATA.MODULES.SHARED.COMPONENTS.PARTIAL_PAYMENT.FORM.TEMPLATE_PLACEHOLDER' | translate"
        [disabled]="!selectedChannel"
        styleClass="am-dropdown"
        appendTo="body"
      ></p-dropdown>
    </div>

    <!-- Summary -->
    <div class="am-summary" *ngIf="!checkDisabled()">
      <lucide-icon name="info" [size]="14"></lucide-icon>
      <div class="am-summary__body" [innerHTML]="summaryHtml"></div>
    </div>

  </div>

  <!-- ── Footer ──────────────────────────────────────────────────────── -->
  <div class="am-footer">
    <button type="button" class="am-btn am-btn-text" (click)="cancel()">
      {{ 'DATA.MODULES.SHARED.COMPONENTS.PARTIAL_PAYMENT.CANCEL' | translate }}
    </button>
    <pay-button
      [label]="'DATA.MODULES.SHARED.COMPONENTS.PARTIAL_PAYMENT.SEND_BTN' | translate"
      variant="primary"
      [disabled]="checkDisabled()"
      (clicked)="send()"
    ></pay-button>
  </div>

</div>
